import { getFontClass } from "../../helpers/fontUtils";

type Props = {
  fontFamily?: string;
};

const SuccessPage = (props: Props) => {
  return (
    <div
      className={`items-center text-xl font-bold h-screen flex flex-col lg:w-[30vw] w-[80vw] mt-4 ${props.fontFamily ? getFontClass(props.fontFamily) : ""}`}
    >
      Your request added succesfully!
    </div>
  );
};

export default SuccessPage;
